import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import OverviewPage from './components/OverviewPage';
import InventoryPage from './components/InventoryPage';
import RetailOrderPage from './components/RetailOrderPage';
import WholesaleOrderPage from './components/WholesaleOrderPage';
import AdminOrdersPage from './components/AdminOrdersPage';
import FinancePage from './components/FinancePage';
import AppLayout from './components/AppLayout';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes with sidebar layout */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <AppLayout>
                <Routes>
                  <Route path="/" element={<OverviewPage />} />
                  <Route path="/inventory" element={<InventoryPage />} />
                  <Route path="/orders/retail" element={<RetailOrderPage />} />
                  <Route path="/orders/wholesale" element={<WholesaleOrderPage />} />
                  <Route path="/orders" element={<AdminOrdersPage />} />
                  <Route path="/finance" element={<FinancePage />} />
                  {/* Redirect old dashboard route to overview */}
                  <Route path="/dashboard" element={<OverviewPage />} />
                </Routes>
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* Catch-all route for debugging */}
        <Route
          path="*"
          element={
            <div className="min-h-screen flex items-center justify-center">
              <div className="text-center">
                <h1 className="text-2xl font-bold text-red-600 mb-4">404 - Page Not Found</h1>
                <p className="text-gray-600 mb-4">The page you're looking for doesn't exist.</p>
                <p className="text-sm text-gray-500 mb-4">Current path: {window.location.pathname}</p>
                <div className="space-x-4">
                  <a href="/login" className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
                    Go to Login
                  </a>
                  <a href="/" className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">
                    Go to Overview
                  </a>
                </div>
              </div>
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
